import {ReportCategoryType} from '@/types/report-category-type'

export {ReportCategoryType as CategoryType}
export type CategoryTypeValue = ReportCategoryType

/* eslint-disable i18next/no-literal-string -- TypeFilter.ALL is a UI-only filter value, not a domain enum */
export const TypeFilter = {
    ALL: 'ALL',
    ...ReportCategoryType,
} as const
/* eslint-enable i18next/no-literal-string */
export type TypeFilterValue = typeof TypeFilter[keyof typeof TypeFilter]

export interface ReportCategoryListItem {
    categoryId: string
    name: string
    description: string | null
    type: CategoryTypeValue
    reportCount: number
    updatedAt: string
    parentCategoryId: string | null
    version: number
}

export interface ReportCategoryDetail extends ReportCategoryListItem {
    ownerAuthUserId: string | null
    createdAt: string
}

import type {AttributeDefinition} from '@/types/attribute-definition'
import type {ErrorLogRef} from '@/types/common'

export interface ReportDefinitionListItem {
    reportDefinitionId: string
    name: string
    description: string | null
    categoryName: string
    categoryId: string
    updatedAt: string
    lastRunAt: string | null
    version: number
}

export interface ReportDefinitionDetail extends ReportDefinitionListItem {
    queryDefinition: {sql: string}
    parameters: AttributeDefinition[]
    retention: string
    ownerAuthUserId: string | null
    createdAt: string
    scheduleCron: string | null
    recipientIdentityIds: string[]
    recipientEmails: string[]
    notificationTemplateKey: string | null
}

export interface ReportSearchResult {
    reportDefinitionId: string
    name: string
    description: string | null
    categoryId: string
    categoryName: string
    categoryType: CategoryTypeValue
    updatedAt: string
}

/* eslint-disable i18next/no-literal-string -- const definitions */
export const ReportExecutionStatus = {
    RUNNING: 'RUNNING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
} as const
export type ReportExecutionStatus = typeof ReportExecutionStatus[keyof typeof ReportExecutionStatus]
/* eslint-enable i18next/no-literal-string */

export interface ReportExecution {
    id: string
    reportDefinitionId: string
    executedBy: string | null
    status: string
    parameterValues: Record<string, unknown>
    resultData: Record<string, unknown>[] | null
    rowCount: number | null
    errorMessage: string | null
    errorLogRef: ErrorLogRef | null
    startedAt: string
    completedAt: string | null
    durationMs: number | null
}

export interface SqlExecute {
    columns: {name: string; type: string; label: string}[]
    rows: Record<string, unknown>[]
    rowCount: number
    truncated: boolean
}

